import type { PieChartData } from 'src/Libs/chart-kit/pie-charts/components/pie-chart.types'
import type { CostSavingChartTraceKey } from 'src/Libs/dynamic-power-prices/cost-saving-chart-trace-keys'
import type { TraceKey } from 'src/Libs/system-charts/shared'

/**
 * Returns the percentage value reflecting the trace values part of the (pie-chart) label.
 */
export const getLabelPercentageValue = (
  data: PieChartData[],
  traceNames: Record<string, string>,
  labelTraces?: TraceKey[] | CostSavingChartTraceKey[]
): number | undefined => {
  if (!labelTraces || labelTraces.length === 0) return undefined

  const traces = labelTraces.map(trace => traceNames[trace])
  const labelTracesSum = data.reduce<number>((prev: number, curr: PieChartData) => {
    if (traces.includes(curr.name) && curr.value) {
      return prev + Number(curr.value.toFixed(2))
    }
    return prev
  }, 0)

  const allTracesSum = data.reduce((prev, curr) => {
    if (curr.value) return prev + Number(curr.value.toFixed(2))
    return prev
  }, 0)

  return allTracesSum === 0 ? 0 : Math.round((labelTracesSum / allTracesSum) * 100)
}
